export default __webpack_public_path__ + "static/media/leftDarkAnchor.58875224.svg";